import React from 'react';
import { motion } from 'framer-motion';

// Import the client logos. Adjust the paths based on your project structure.
import vMartLogo from '../images/v-mart-logo.png';
import vishalLogo from '../images/vishal-mega-mart-logo.png';
import dMartLogo from '../images/d-mart-logo.png';
import dukeLogo from '../images/duke-logo.png';

const ClientsUpdated = () => {
  const clients = [
    { id: 1, name: 'V Mart', image: vMartLogo },
    { id: 2, name: 'Vishal Mega Mart', image: vishalLogo },
    { id: 3, name: 'D Mart', image: dMartLogo },
    { id: 4, name: 'Duke', image: dukeLogo },
  ];

  // 🔁 Repeat multiple times so the strip is longer than the viewport
  const items = [
    ...clients,
    ...clients,
    ...clients,
    ...clients, // 4 groups
  ];

  return (
    <section id="clients" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        {/* Section title pill */}
        <div className="flex justify-center mb-10">
          <motion.div
            className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-6 py-2 shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <span className="h-2.5 w-2.5 rounded-full bg-yellow-400" />
            <span className="font-playfair font-bold text-lg md:text-xl text-white">
              Our Valued Clients
            </span>
          </motion.div>
        </div>

        {/* Infinite marquee */}
        <div className="overflow-hidden">
          <motion.div
            className="flex whitespace-nowrap"
            initial={{ x: 0 }}
            animate={{ x: ['0%', '-25%'] }} // move by one group (1/4 of track)
            transition={{
              duration: 10,
              ease: 'linear',
              repeat: Infinity,
            }}
          >
            {items.map((client, index) => (
              <motion.div
                key={`${client.id}-${index}`}
                className="flex flex-col items-center px-6 flex-shrink-0"
                whileHover={{ scale: 1.05, y: -4 }}
              >
                {/* Circle logo */}
                <div className="w-24 h-24 md:w-32 md:h-32 bg-white rounded-full shadow-md hover:shadow-lg transition-shadow duration-300 flex items-center justify-center overflow-hidden border border-amber-700/40">
                  <img
                    src={client.image}
                    alt={client.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="mt-3 font-semibold text-gray-800 text-center text-sm md:text-base">
                  {client.name}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClientsUpdated;